<template>
  <span class="icon-wraper">
    <svg
      v-if="name === 'icon_1_0'"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path d="M1.5 14.625H16.5V9V3.375H9H1.5V9V14.625Z" :stroke="fillColor" />
      <path
        d="M1.5 3.375L9 9L16.5 3.375"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path d="M9 3.375H1.5V9" :stroke="fillColor" stroke-linecap="round" />
      <path d="M16.5 9V3.375H9" :stroke="fillColor" stroke-linecap="round" />
    </svg>
    <svg
      v-if="name === 'icon_1_1'"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path d="M1.5 16.5H16.5" :stroke="fillColor" stroke-linecap="round" />
      <path
        d="M3 2.72727C3 2.72727 5.625 1.5 9 1.5C12.375 1.5 15 2.72727 15 2.72727V4.875H3V2.72727Z"
        :stroke="fillColor"
      />
      <path d="M3.75 4.875V14.25" :stroke="fillColor" stroke-linecap="round" />
      <path d="M6.375 4.875V14.25" :stroke="fillColor" stroke-linecap="round" />
      <path d="M9 4.875V14.25" :stroke="fillColor" stroke-linecap="round" />
      <path
        d="M11.625 4.875V14.25"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path d="M14.25 4.875V14.25" :stroke="fillColor" stroke-linecap="round" />
      <path d="M15.375 14.25H2.625V16.5H15.375V14.25Z" :stroke="fillColor" />
    </svg>
    <svg
      v-if="name === 'icon_1_2'"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5C10.8707 16.5 12.5815 15.8151 13.8952 14.6823"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path
        d="M9 12C10.6569 12 12 10.6569 12 9C12 7.34314 10.6569 6 9 6C7.34314 6 6 7.34314 6 9C6 10.6569 7.34314 12 9 12Z"
        :stroke="fillColor"
      />
      <path
        d="M12 9C12 10.2426 13.0074 11.25 14.25 11.25C15.4926 11.25 16.5 10.2426 16.5 9"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path d="M12 9.375V6" :stroke="fillColor" stroke-linecap="round" />
    </svg>
    <svg
      v-if="name === 'icon_1_3'"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M3 11.25H15V15.75C15 16.1642 14.6642 16.5 14.25 16.5H3.75C3.33579 16.5 3 16.1642 3 15.75V11.25Z"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path
        d="M15 11.25V2.25C15 1.83579 14.6642 1.5 14.25 1.5H3.75C3.33579 1.5 3 1.83579 3 2.25V11.25"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path d="M8.25 13.875H9.75" :stroke="fillColor" stroke-linecap="round" />
    </svg>

    <svg
      v-if="name === 'icon_1_4'"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M15.375 3H2.625C2.00368 3 1.5 3.50368 1.5 4.125V13.875C1.5 14.4963 2.00368 15 2.625 15H15.375C15.9963 15 16.5 14.4963 16.5 13.875V4.125C16.5 3.50368 15.9963 3 15.375 3Z"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path
        d="M1.5 4.125C1.5 3.50368 2.00368 3 2.625 3H15.375C15.9963 3 16.5 3.50368 16.5 4.125V7.5H1.5V4.125Z"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path
        d="M3 5.25C3 4.83579 3.33579 4.5 3.75 4.5C4.16421 4.5 4.5 4.83579 4.5 5.25C4.5 5.66421 4.16421 6 3.75 6C3.33579 6 3 5.66421 3 5.25Z"
        fill="#CFD7F7"
      />
      <path
        d="M5.25 5.25C5.25 4.83579 5.58579 4.5 6 4.5C6.41421 4.5 6.75 4.83579 6.75 5.25C6.75 5.66421 6.41421 6 6 6C5.58579 6 5.25 5.66421 5.25 5.25Z"
        fill="#CFD7F7"
      />
    </svg>

    <svg
      v-if="name === 'icon_1_5'"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9 12.75C11.071 12.75 12.75 11.071 12.75 9C12.75 6.92895 11.071 5.25 9 5.25C6.92895 5.25 5.25 6.92895 5.25 9C5.25 11.071 6.92895 12.75 9 12.75Z"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path d="M9 1.5V16.5" :stroke="fillColor" stroke-linecap="round" />
      <path
        d="M1.5 9L6.75 9.00315"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path d="M1.5 9.00293H16.5" :stroke="fillColor" stroke-linecap="round" />
    </svg>
    <svg
      v-if="name === 'icon_1_6'"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M9 6C10.2426 6 11.25 4.99264 11.25 3.75C11.25 2.50736 10.2426 1.5 9 1.5C7.75736 1.5 6.75 2.50736 6.75 3.75C6.75 4.99264 7.75736 6 9 6Z"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path
        d="M11.625 16.5V13.125L13.5 12L12 7.125C12 7.125 10.5 6 9 6C7.5 6 6 7.125 6 7.125L4.5 11.625L6.375 13.125V16.5"
        :stroke="fillColor"
        stroke-linecap="round"
      />
    </svg>
    <svg
      v-if="name === 'icon_1_7'"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M15.75 5.625H2.25C1.83579 5.625 1.5 5.96079 1.5 6.375V14.625C1.5 15.0392 1.83579 15.375 2.25 15.375H15.75C16.1642 15.375 16.5 15.0392 16.5 14.625V6.375C16.5 5.96079 16.1642 5.625 15.75 5.625Z"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path
        d="M9 2.625L6 5.625H12L9 2.625Z"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path d="M4.5 9H11.25" :stroke="fillColor" stroke-linecap="round" />
      <path d="M4.5 12H7.5" :stroke="fillColor" stroke-linecap="round" />
    </svg>

    <svg
      v-if="name === 'icon_2_0'"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M15.75 3H2.25C1.83579 3 1.5 3.33579 1.5 3.75V14.25C1.5 14.6642 1.83579 15 2.25 15H15.75C16.1642 15 16.5 14.6642 16.5 14.25V3.75C16.5 3.33579 16.1642 3 15.75 3Z"
        :stroke="fillColor"
      />
      <path
        d="M6.375 9.375C7.20341 9.375 7.875 8.70341 7.875 7.875C7.875 7.04659 7.20341 6.375 6.375 6.375C5.54659 6.375 4.875 7.04659 4.875 7.875C4.875 8.70341 5.54659 9.375 6.375 9.375Z"
        :stroke="fillColor"
      />
      <path
        d="M8.625 11.625C8.625 10.3824 7.61764 9.375 6.375 9.375C5.13236 9.375 4.125 10.3824 4.125 11.625"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path d="M10.5 7.5H13.5" :stroke="fillColor" stroke-linecap="round" />
      <path d="M11.25 10.5H13.5" :stroke="fillColor" stroke-linecap="round" />
    </svg>
    <svg
      v-if="name === 'icon_2_1'"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M6 8.25L3.75 4.5L1.5 8.25"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.75 10.5C4.99264 10.5 6 9.49264 6 8.25H1.5C1.5 9.49264 2.50736 10.5 3.75 10.5Z"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path
        d="M16.5 8.25L14.25 4.5L12 8.25"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.25 10.5C15.4926 10.5 16.5 9.49264 16.5 8.25H12C12 9.49264 13.0074 10.5 14.25 10.5Z"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path d="M9 2.25V15.75" :stroke="fillColor" stroke-linecap="round" />
      <path d="M3.75 4.5H9H14.25" :stroke="fillColor" stroke-linecap="round" />
      <path d="M3.75 4.5H9H14.25" :stroke="fillColor" stroke-linecap="round" />
      <path
        d="M14.25 15.75H9H3.75"
        :stroke="fillColor"
        stroke-linecap="round"
      />
    </svg>
    <svg
      v-if="name === 'icon_2_2'"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M9.5625 13.875H7.875L4.125 15.75V13.875H1.5V2.625H16.5V6.75"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path
        d="M10.875 9.45C10.875 9.04999 13.5 8.25 13.5 8.25C13.5 8.25 16.125 9.04999 16.125 9.45C16.125 12.65 13.5 14.25 13.5 14.25C13.5 14.25 10.875 12.65 10.875 9.45Z"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path
        d="M4.5 5.625H5.625H6.75"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path d="M4.5 7.875H6.75H9" :stroke="fillColor" stroke-linecap="round" />
    </svg>
    <svg
      v-if="name === 'icon_2_3'"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M14.25 1.5H3.75C3.33579 1.5 3 1.83579 3 2.25V15.75C3 16.1642 3.33579 16.5 3.75 16.5H14.25C14.6642 16.5 15 16.1642 15 15.75V2.25C15 1.83579 14.6642 1.5 14.25 1.5Z"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path
        d="M11.25 8.625L9.95081 7.32581M9.95081 7.32581C10.2901 6.98651 10.5 6.51776 10.5 6C10.5 4.96448 9.66052 4.125 8.625 4.125C7.58948 4.125 6.75 4.96448 6.75 6C6.75 7.03552 7.58948 7.875 8.625 7.875C9.14276 7.875 9.61151 7.66515 9.95081 7.32581Z"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path
        d="M6.375 11.25H11.625"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path d="M6.375 13.5H9" :stroke="fillColor" stroke-linecap="round" />
    </svg>
    <svg
      v-if="name === 'icon_2_4'"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M3 16.5V2.25C3 1.83579 3.33579 1.5 3.75 1.5H14.25C14.6642 1.5 15 1.83579 15 2.25V16.5L9 13.3977L3 16.5Z"
        :stroke="fillColor"
      />
      <path
        d="M8.98114 5.23096V9.73096"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path
        d="M6.73114 7.48096H11.2311"
        :stroke="fillColor"
        stroke-linecap="round"
      />
    </svg>
    <svg
      v-if="name === 'icon_2_5'"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M14.625 2.25H3.375C2.75368 2.25 2.25 2.75368 2.25 3.375V14.625C2.25 15.2463 2.75368 15.75 3.375 15.75H14.625C15.2463 15.75 15.75 15.2463 15.75 14.625V3.375C15.75 2.75368 15.2463 2.25 14.625 2.25Z"
        :stroke="fillColor"
      />
      <path
        d="M9 10.7344V9.23438C10.2426 9.23438 11.25 8.22701 11.25 6.98438C11.25 5.74174 10.2426 4.73438 9 4.73438C7.75736 4.73438 6.75 5.74174 6.75 6.98438"
        :stroke="fillColor"
        stroke-linecap="round"
      />
      <path
        d="M9 12.7344C9.24162 12.7344 9.4375 12.9303 9.4375 13.1719C9.4375 13.4135 9.24162 13.6094 9 13.6094C8.75838 13.6094 8.5625 13.4135 8.5625 13.1719C8.5625 12.9303 8.75838 12.7344 9 12.7344Z"
        fill="#CFD7F7"
        :stroke="fillColor"
      />
    </svg>
  </span>
</template>
<script>
import { mapGetters } from "vuex";
import commonMixin from "@/components/common/commonMixin.vue";
export default {
  props: {
    name: {
      type: String,
      default: "icon1",
    },
  },
  components: {},
  mixins: [commonMixin],
  data() {
    return {};
  },
  async created() {},
  destroyed() {},
  beforeDestroy() {},
  watch: {},
  computed: {
    ...mapGetters({
      isDarkMode: "user/isDarkMode",
    }),
    fillColor() {
      return this.isDarkMode ? "#CFD7F7" : "#2D4CD3";
    },
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.icon-wraper {
  width: 18px;
  height: 18px;
  aspect-ratio: 1/1;
  > svg {
    position: relative;
    top: 2px;
  }
}
</style>
